import { TwDatePicker } from '@cofit/components/TwDatePicker';
import moment from 'moment';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BranchConstants } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var BirthdayPopup = function BirthdayPopup(_ref) {
  var _ref2;

  var setDate = _ref.setDate,
      date = _ref.date;

  var _useRouter = useRouter(),
      locale = _useRouter.locale,
      defaultLocale = _useRouter.defaultLocale;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var handleDateChange = useCallback(function (value) {
    setDate(moment(value));
  }, [setDate]);
  return /*#__PURE__*/_jsx(TwDatePicker, {
    t: t,
    supportTwYearFormat: !BranchConstants.IS_CHINA_SITE,
    closeOnSelect: false,
    disablePortal: true,
    onChange: handleDateChange,
    value: date === null || date === void 0 ? void 0 : date.toDate(),
    locale: (_ref2 = locale || defaultLocale) === null || _ref2 === void 0 ? void 0 : _ref2.toLowerCase(),
    e2eid: "common_BirthdayPopup_TwDatePicker"
  });
};